import { useState } from "react";

export function AluminiCard({
  imageUrl, name, profession, location, alt, yearOfPassing
  }) {
    const [showContactInfo, setShowContactInfo] = useState(false);

    const handleConnect = () => {
      setStatus("pending");
      onConnect();
    };

    return (
      <div className="bg-white rounded-lg shadow hover:shadow-md transition-all duration-300 max-w-xs p-4 sm:p-5 transform hover:-translate-y-1">
      <div className="flex flex-col items-center text-center">
        <div className="w-20 h-20 mb-3 rounded-full overflow-hidden ring-2 ring-gray-100">
          <img
            src={imageUrl || "/default-avatar.jpg"}
            alt={alt || "Profile picture"}
            className="w-full h-full object-cover"
          />
        </div>

        <h2 className="text-xl font-semibold text-gray-900 mb-1">
          {name}
        </h2>
        <p className="text-xs text-pink-700 bg-pink-50 px-2 py-1 rounded-md mb-2">
          Batch of {yearOfPassing}
        </p>

        <div className="text-sm text-gray-700 flex items-center mb-1">
          <i className="fas fa-briefcase text-blue-500 mr-1"></i>
          {profession}
        </div>

        <div className="text-sm text-gray-500 flex items-center">
          <i className="fas fa-location-dot text-blue-500 mr-1"></i>
          {location}
        </div>
      </div>
    </div>
    );
  }




